import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const NavBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = (): void => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      setMobileMenuOpen(false);
    }
  };

  return (
    <motion.nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md py-2" : "bg-transparent py-4"
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <div className="h-12 w-auto">
              <Link to="/">
              <img
                src="/lovable-uploads/a640d2a4-f462-47db-aaa6-331b0e57fec0.png"
                alt="Woost Logo"
                className="h-full w-auto"
              />
              </Link>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6">
            <button
              onClick={() => scrollToSection("services")}
              className="text-gray-700 hover:text-woost-blue font-medium"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("creators")}
              className="text-gray-700 hover:text-woost-blue font-medium"
            >
              Creators
            </button>
            <button
              onClick={() => scrollToSection("case-studies")}
              className="text-gray-700 hover:text-woost-blue font-medium"
            >
              Case Studies
            </button>

            <Button
              onClick={() => scrollToSection("contact")}
              className="bg-woost-blue hover:bg-woost-blue-dark text-white"
            >
              <Link to={"/#contact"}>Get in Touch</Link>
            </Button>

            <Link to="https://partners.woost.io" target="_blank">
              <Button className="bg-woost-blue hover:bg-woost-blue-dark text-white">
                Dashboard
              </Button>
            </Link>
            <Link to="/blog">
              <Button className="bg-woost-blue hover:bg-woost-blue-dark text-white">
               Blog
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-gray-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <motion.div
          className="md:hidden bg-white shadow-lg"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.2 }}
        >
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <button
              onClick={() => scrollToSection("services")}
              className="text-gray-700 hover:text-woost-blue font-medium py-2"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection("creators")}
              className="text-gray-700 hover:text-woost-blue font-medium py-2"
            >
              Creators
            </button>
            <button
              onClick={() => scrollToSection("case-studies")}
              className="text-gray-700 hover:text-woost-blue font-medium py-2"
            >
              Case Studies
            </button>
            <Button
              onClick={() => scrollToSection("contact")}
              className="bg-woost-blue hover:bg-woost-blue-dark text-white w-full"
            >
              Get in Touch
            </Button>

            <Link to="https://partners.woost.io">
              <Button className="bg-woost-blue hover:bg-woost-blue-dark text-white w-full">
                Dashboard
              </Button>
            </Link>
            <Link to="/blog">
              <Button className="bg-woost-blue hover:bg-woost-blue-dark text-white w-full">
               Blog
              </Button>
            </Link>
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default NavBar;
